/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The monetary amount.
 * @export
 * @interface Amount
 */
export interface Amount {
    /**
     * The value of the amount object. Decimal point inline with correct precision.
     * @type {string}
     * @memberof Amount
     */
    value?: string;
    /**
     * Currency of the amount object.
     * @type {string}
     * @memberof Amount
     */
    currency?: string;
}

/**
 * Check if a given object implements the Amount interface.
 */
export function instanceOfAmount(value: object): value is Amount {
    return true;
}

export function AmountFromJSON(json: any): Amount {
    return AmountFromJSONTyped(json, false);
}

export function AmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Amount {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function AmountToJSON(json: any): Amount {
    return AmountToJSONTyped(json, false);
}

export function AmountToJSONTyped(value?: Amount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'currency': value['currency'],
    };
}

